import React from 'react';
import PageBanner from '@/components/site/PageBanner';
import ToolNav from '@/components/site/ToolNav';
import SEO from '@/components/site/SEO';
import EMICalculator from './EMICalculator';

const EMICalcPage = () => (
  <main>
    <SEO
      title="Home Loan EMI Calculator | Calculate Monthly EMI Online | Finirio"
      description="Calculate your home loan EMI online with Finirio's free EMI calculator. Enter loan amount, tenure and interest rate to plan your monthly instalments and total interest."
      path="/emi-calculator"
      keywords="emi calculator, home loan emi calculator, loan emi calculator india, monthly emi"
    />
    <PageBanner title="EMI Calculator" crumbs={[ 'Calci and Docs', 'EMI Calculator' ]} />
    <ToolNav />
    <section className="py-14 bg-white">
      <div className="max-w-[1240px] mx-auto px-4 lg:px-6">
        <EMICalculator />
      </div>
    </section>
  </main>
);

export default EMICalcPage;
